<template>
  <div class="c-table" ref="aTable">
    <!-- <Spin size="large" fix v-if="loading" /> -->
    <el-table
      ref="table"
      border
      stripe
      :height="height"
      v-loading="loading"
      class="common-el-table-styles"
      :data="data"
      @sort-change="sortChange"
      @cell-mouse-enter="rowEnter"
      @cell-mouse-leave="rowLeave"
      @header-dragend="headerDragend"
      @selection-change="select"
    >
      <el-table-column type="selection" width="39"> </el-table-column>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :fixed="col.fixed"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
        :sortable="col.sortable"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'validPlanCounts'" class="c-pulse-wrap">
            <el-button type="text" @click="$emit('on-show', { key: col.key, row: scope.row })">{{ scope.row[col.key] }}</el-button>
          </div>
          <span
            v-else-if="
              ['pv', 'clickNum', 'click', 'paperAmount', 'amount', 'materialPv', 'activeNum', 'register', 'payCount', 'payAmount'].includes(
                col.key
              )
            "
          >
            {{ scope.row[col.key] | toThousands }}
          </span>
          <span v-else-if="(col.key.indexOf('Rate') > -1 || col.key.indexOf('Retain') > -1) && !['deductRate'].includes(col.key)">{{
            scope.row[col.key] | toPercentFixed
          }}</span>
          <div v-else-if="['adAccount'].includes(col.key)" class="accountCol">
            <el-button type="text" @click="$emit('on-show', { key: col.key, row: scope.row })">{{ scope.row[col.key] }}</el-button>
            <p>内部ID：{{ scope.row['adAccountId'] }}</p>
            <p>计划主ID：{{ scope.row['advertiserId'] }}</p>
          </div>
          <div v-else-if="col.key === 'budget'">
            <div v-if="scope.row.editBudget">
              <Col span="11">
                <RadioGroup v-model="scope.row.newbudgetMode" vertical>
                  <Radio :label="0" :disabled="![10, 16, 32, 45, 6].includes(media)"><span>不限</span></Radio>
                  <Radio :label="1">
                    <el-input
                      placeholder=""
                      v-model="scope.row.newbudget"
                      @blur="inputTrim('newbudget', scope.row, true)"
                      style="width: 50px"
                    ></el-input>
                  </Radio>
                </RadioGroup>
              </Col>
              <Col span="13" style="padding-top: 33px">
                <Button type="primary" :loading="saving" size="small" @click="editBudget(scope.row)">
                  <span v-if="!saving">确定</span>
                </Button>
                <Button size="small" @click="cancelEdit(scope.row, 'editBudget')">取消</Button>
              </Col>
            </div>
            <div v-else>
              <span v-if="scope.row.budget > 0 || scope.row.budgetMode === 1">{{ scope.row.budget | toThousands }}</span>
              <span v-else>不限</span>
              <Icon
                v-if="scope.row.editState"
                @click="changEdit(scope.row, 'editBudget', 'budget', 'budgetMode')"
                type="md-create"
                class="g-pull-right m-edit"
                size="18"
                color="#409EFF"
              />
            </div>
          </div>
          <div v-else-if="col.key === 'day_budget_schedule'">
            <span>{{ scope.row[col.key] }}</span>
            <Icon
              v-if="scope.row.editState"
              type="md-create"
              class="g-pull-right m-edit"
              size="18"
              color="#409EFF"
              @click="changbudgetModel(scope.row)"
            />
          </div>
          <span v-else-if="col.key === 'synTime'">{{ scope.row.synTime | datetimeToSec }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <betch-budget
      v-model="budgetModel"
      :data="budgets"
      :columns="budgetColumns"
      :type="budgetType"
      :account="budgetAccount"
      @refresh="$emit('on-refresh')"
    ></betch-budget>
  </div>
</template>
<script>
import budgetColumns from '../data/budget.columns'
import { isEmpty, isArray, trim } from '@/common/js/utils'
import { modifyAccountBudget, modifyBudget } from '@/api/convert.model'
import BetchBudget from '@/components/converter/batch-budget.vue'
export default {
  name: 'aTable',
  components: {
    BetchBudget
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    columns: {
      type: Array,
      default() {
        return []
      }
    },
    media: {
      type: Number
    },
    height: {
      type: Number
    }
  },
  methods: {
    inputTrim(key, row, fixed) {
      let val = parseFloat(row[key])
      if (isEmpty(val) || typeof val !== 'number') {
        this.$set(row, key, 0)
        return
      }
      val = trim(val)
      if (fixed) {
        val = val * 100
        val = Math.floor(val) / 100
      } else val = parseInt(val)
      this.$set(row, key, val)
    },
    sortChange(column) {
      let orderName
      if (column.order === 'ascending') orderName = 'asc'
      else if (column.order === 'descending') orderName = 'desc'
      this.$emit('on-sort', { sort: column.prop, order: orderName })
    },
    // 鼠标经过显示修改笔
    rowEnter(row) {
      this.$set(row, 'editState', true)
    },
    rowLeave(row) {
      this.$set(row, 'editState', false)
    },
    // 改变编辑状态
    changEdit(row, key, field, field2) {
      let value = row[field]
      let value2 = row[field2]
      if (value < 0) value = 0
      if (value2 < 0) value2 = 0
      this.data.forEach((ret) => {
        this.$set(ret, key, false)
      })
      this.$set(row, `new${field}`, value)
      this.$set(row, `new${field2}`, value2)
      this.$set(row, key, true)
    },
    cancelEdit(row, key) {
      this.saving = false
      this.$set(row, key, 0)
    },
    changbudgetModel(row) {
      let budgetSchedule = [{ mon: 0, tue: 0, wed: 0, thur: 0, fri: 0, sat: 0, sun: 0 }]
      const { day_budget_schedule, adAccountId } = row
      if (isArray(day_budget_schedule)) {
        const [mon, tue, wed, thur, fri, sat, sun] = day_budget_schedule
        budgetSchedule = [{ mon, tue, wed, thur, fri, sat, sun }]
      }
      this.budgets = budgetSchedule
      this.budgetModel = true
      this.budgetAccount = adAccountId
    },
    // 修改预算
    editBudget(row) {
      var data = {
        adAccountId: row.adAccountId,
        budgetMode: row.newbudgetMode
      }
      if (row.newbudgetMode === 1) data.newAdbudget = row.newbudget

      const callback = (ret) => {
        this.saving = false
        if (ret) {
          // 修改成功后更新
          this.$set(row, 'editBudget', false)
          this.$set(row, 'budget', row.newbudgetMode === 1 ? row.newbudget : 0)
          this.$set(row, 'budgetMode', row.newbudgetMode)
          this.$emit('on-refresh')
        }
      }
      this.saving = true
      if (this.media === 32) modifyBudget({ ad_account_id: row.adAccountId, day_budget: data.newAdbudget || 0, bizType: 4 }).then(callback)
      else modifyAccountBudget(data).then(callback)
    },
    select(val) {
      this.$emit('on-select', val)
    },
    headerDragend(n, o, column) {
      this.$emit('header-dragend', { n, o, column })
    },
    doLayout() {
      this.$refs.table.doLayout()
    }
  },
  data() {
    return {
      saving: null, // 修改请求状态
      budgetModel: null,
      budgetType: 4,
      budgetAccount: 0,
      budgetColumns: [],
      budgets: []
    }
  },
  created() {
    const s_max = 500
    this.budgetColumns = budgetColumns.map((ret) => {
      ret.render = (h, params) => {
        return h('InputNumber', {
          props: {
            step: 100,
            value: params.row[ret.key],
            min: s_max,
            max: 100000000
          },
          on: {
            'on-change': (event) => {
              this.budgets[params.index][ret.key] = event
            },
            'on-blur': () => {
              const event = params.row[ret.key]
              if (event && event < s_max) {
                this.$Message.warning(`分日预算最小值为 ${s_max}`)
                this.budgets[params.index][ret.key] = s_max
              } else if (event && event > 100000000) {
                this.$Message.warning('分日预算最大值为 100000000')
                this.budgets[params.index][ret.key] = 100000000
              }
            }
          },
          style: {
            width: '68px'
          }
        })
      }
      return ret
    })
  }
}
</script>
<style lang="scss" scoped>
.c-table {
  position: relative;
  background-color: #fff;

  .accountCol p {
    line-height: 20px;
    margin: 0;
  }
}
</style>
